import { CircularProgress } from "@mui/material";
import IndieButton from "./IndieButton";

const { WorkspacesOutlined } = require("@mui/icons-material");
const { useTranslation } = require("react-i18next")

const IndieUpdateStatusButton = ({label, loading, ...params}) => {
    const { t } = useTranslation();
    return <IndieButton startIcon={loading ? <CircularProgress color="inherit" size={18} /> : <WorkspacesOutlined/>} variant="outlined" color="success" {...params}>{label ? label : t("label.button.updateStatus")}</IndieButton>
}

export default IndieUpdateStatusButton;